import { render, staticRenderFns } from "./adminLessonDetails.vue?vue&type=template&id=e4c3d6cc&scoped=true&"
import script from "./adminLessonDetails.vue?vue&type=script&lang=js&"
export * from "./adminLessonDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c3d6cc",
  null
  
)

export default component.exports

/* vue-cli-plugin-import-components */
const vueCliInstallComponent = require("!../../node_modules/vue-cli-plugin-import-components/dist/runtime/installComponents.js")
import AdminAnnotationItem from "@/components/admin/adminAnnotationItem.vue";
import AdminLessonItem from "@/components/admin/adminLessonItem.vue";
import CreateInputModal from "@/components/createInputModal.vue";
import Player from "@/components/player/Player.vue";
vueCliInstallComponent(component, {AdminAnnotationItem, AdminLessonItem, CreateInputModal, Player});